import TYPES from '@/modules/shared/types';

// Domain
import { EmailRepository } from '../../domain/repositories/email-repository';
import Inject from '@/modules/shared/domain/di/inject';
import Injectable from '@/modules/shared/domain/di/injectable';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class EmailHttpRepository implements EmailRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  exists(email: string): Promise<boolean> {
    const endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/emails/exists/`;

    return new Promise((resolve, reject) => {
      this.http_connector.execute(endpoint, 'POST', { email })
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data.exists);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
